import { Action } from '@ngrx/store';

import { AuthenticationActionTypes } from './authentication.actions';

export interface AuthenticationState {
    isAuthenticated: boolean;
}

export const emptyAuthenticationState: AuthenticationState = {
    isAuthenticated: false
};

export const initialAuthenticationState: AuthenticationState = emptyAuthenticationState;

export function authenticationReducer(state = initialAuthenticationState, action: Action): AuthenticationState {
    switch (action.type) {
        case AuthenticationActionTypes.Login:
            return { ...state, isAuthenticated: true };

        case AuthenticationActionTypes.Logout: {
            return { ...state, isAuthenticated: false };
        }

        default:
            return state;
    }
}
